import { FC } from "react";
import { Button as AntButton, Modal } from 'antd';
import SelectCampus from '../../SelectCampus';
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const SelectCampusModal: FC<IProps> = ({ visible, setVisible }) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('board.notice.title6')}
      visible={visible}
      onCancel={() => setVisible(false)}
      width={300}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="close"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <div className="flex flex-justify-center">
        <div>
          <SelectCampus className="w-200" />
        </div>
      </div>
    </Modal>
  );
}

export default SelectCampusModal;
